module.exports = __webpack_public_path__ + "img/honor (7).a3ef3d85.jpg";